<template>
  <div>
    <div id="overlay" v-if="loading">
      <div class="spinner"></div>
      <br/>
      <h4>Loading...</h4>
    </div>
    <form>
      <div class="p-grid">
        <div class="p-col">
          <Button class="p-button-raised p-button-rounded" @click.prevent="openBasic" style="float: right"
                  icon="pi pi-plus"/>
        </div>
      </div>
      <Dialog header="Reward Point" :modal="true" :visible.sync="displayBasic"
              :closable=false :style="{width: '50vw'}" :contentStyle="{'overflow': 'visible'}">
        <div class="p-fluid p-formgrid p-grid ">
          <!-- <div class="p-field p-col-12 p-md-4">
            <label for="name">Name<span style="color:red">*</span></label>
            <InputText ref="name" v-model.trim="name" id="name"/>
          </div> -->
          <div class="p-field p-col-12 p-md-3">
            <label for="property">From</label>
            <InputNumber v-model="amountFrom"  onfocus="if (this.value === '0.00'){this.value = ''}" :minFractionDigits="2" :maxFracionDigits="4"/>
          </div>
          <div class="p-field p-col-12 p-md-3">
            <label for="property">To</label>
            <InputNumber v-model="amountTo" onfocus="if (this.value === '0.00'){this.value = ''}" :minFractionDigits="2" :maxFracionDigits="4"/>
          </div>
          <div class="p-field p-col-12 p-md-3">
            <label for="property">Reward</label>
             <InputNumber v-model="point" placeholder="Point" onfocus="if (this.value === '0.00'){this.value = ''}" :minFractionDigits="2" :maxFracionDigits="4"/>
            <!-- <div class="p-field-radiobutton">
              <RadioButton  name="reward" value="Flat" v-model="reward" @change="chooseRewardPercent"/>
              <label >Flat</label>
            </div>
            <div class="p-field-radiobutton">
              <RadioButton  name="reward" value="Percentage" v-model="reward" @change="chooseRewardAmt"/>
              <label >Percentage</label>
            </div> -->
          </div>
          <!-- <div class="p-field p-col-12 p-md-3"  v-if="choosePercent">
            <InputNumber v-model="rewardPercent" placeholder="Reward Percent"/>
          </div> -->

        </div>
        <template #footer>
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-6">
              <Button class="p-button-raised p-button-rounded" :label="editing?'Update':'Add'" @click.prevent="addRewardPoint"
              />
              <!-- <Button class="p-button-raised p-button-info" v-if="!editing" label="Add & New" -->
              <!-- /> -->
              <Button class="p-button-raised p-button-danger" label="Cancel"
                      @click.prevent="closeBasic"/>
            </div>
          </div>
        </template>
      </Dialog>
    </form>
    <div class="p-field p-col-12 p-md-12">
      <DataTable :value="rewardPointLists"
        :paginator="true"
        :rows="4"
        class="p-datatable-responsive p-datatable-gridlines"
        data-key="id"
      >
        <!-- <Column header="Reward Name" field="name"/> -->
        <Column field="amountFrom" header="From"/>
        <Column header="To" field="amountTo"/>
         <Column header="Point" field="point"/>
        <Column header="Action">
          <template #body="slotProps">
            <!-- <Button class="p-button-secondary p-button-text" label="Edit"
            />
            <Button class="p-button-danger p-button-text" label="Remove"
            /> -->

            <Button type="button" icon="pi pi-pencil" class="p-button-success p-button-sm"
                  @click="editRewardPoint(slotProps.data)"/>
          <Button icon="pi pi-trash" class="p-button-danger p-button-sm"
                  @click="openDeleteDialog(slotProps.data.id)"/>

          </template>
        </Column>
      </DataTable>
    </div>
     <DeleteDialog v-model="showDeleteDialog" @cancel="closeDeleteDialog" @deleted="deleteRewardPoint"/>
  </div>
</template>
<script>
import Dialog from 'primevue/dialog'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import RadioButton from 'primevue/radiobutton'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import InputNumber from 'primevue/inputnumber'
import DeleteDialog from '../../layout/dialog'

export default {
  name: 'rewardPoint',
  data() {
    return {
      name: '',
      displayBasic: false,
      dialogShow: false,
      editing: false,
      id: null,
      loading: false,
      amountFrom: 0.0,
      amountTo: 0.0,
      point: 0.0,
      reward: '',
      showDeleteDialog: false
    }
  },
  computed: {
    rewardPointLists() {
      return this.$store.state.pos.rewardPointLists
    }
  },
  mounted() {
    this.rewardPointList()
  },
  methods: {
    openBasic() {
      this.displayBasic = true
    },
    closeBasic() {
      this.displayBasic = false
      this.reset()
    },
    async rewardPointList() {
      await this.$store.dispatch('loadRewardPointList')
    },
    async addRewardPoint() {
      if (this.amountFrom === 0.0) {
        this.$toast.add({severity: 'warn', summary: '', detail: 'Please enter from amount!', life: 3000})
        return
      }
      if (this.amountTo === 0.0) {
        this.$toast.add({severity: 'warn', summary: '', detail: 'Please enter to amount!', life: 3000})
        return
      }
      if (this.point === 0.0) {
        this.$toast.add({severity: 'warn', summary: '', detail: 'Please enter point!', life: 3000})
        return
      }
      let rewardPoint = {
        id: this.id,
        amountFrom: this.amountFrom,
        amountTo: this.amountTo,
        point: this.point
      }
      let response = ''
      if (!this.editing) {
        response = await this.$store.dispatch('saveRewardPoints', rewardPoint)
      } else {
        response = await this.$store.dispatch('updateRewardPoint', rewardPoint)
      }
      if (response.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 3000})
        this.cancel()
        this.reset()
        this.displayBasic = false
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: 'Something went wrong!', life: 3000})
      }
    },
    reset() {
      this.reward = 0.0
      this.amountFrom = 0.0
      this.amountTo = 0.0
    },
    editRewardPoint(data) {
      this.editing = true
      this.id = data.id
      this.amountFrom = data.amountFrom
      this.amountTo = data.amountTo
      this.point = data.point
      this.openBasic()
    },
    openDeleteDialog(id) {
      this.showDeleteDialog = true
      this.counterId = id
    },
    async deleteRewardPoint(value) {
      this.showDeleteDialog = true
      if (value.trim() === '') {
        this.$toast.add({severity: 'warn', summary: '', detail: 'Delete reason cannot be empty!', life: 3000})
        return
      }
      let deleteRe = {
        id: this.counterId,
        deleteReason: value
      }
      let resp = await this.$store.dispatch('deleteRewardPoint', deleteRe)
      if (resp.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 3000})
      } else {
        this.$toast.add({severity: 'danger', summary: '', detail: resp.data.message, life: 3000})
      }
      this.closeDeleteDialog()
    },
    closeDeleteDialog(data) {
      this.showDeleteDialog = false
    },
    cancel() {
      this.editing = false
      this.point = 0.0
      this.amountFrom = 0.0
      this.amountTo = 0.0
      this.showCounterDialog = false
    }
  },
  components: {
    Dialog,
    Button,
    InputText,
    RadioButton,
    DataTable,
    Column,
    InputNumber,
    DeleteDialog
  }
}
</script>
<style scoped src="@../../../static/css/dialogEntry.css">
</style>



// WEBPACK FOOTER //
// RewardPoint.vue?ff32cb1a